import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import FormikControl from "../FormikControl";
import { selectCurrentCycle, selectAllInitialSteps } from "../../../slices/common";
import { useMemo, useEffect } from "react";
import { startValidationSchema } from "../../../../utils/formik/validationSchema"
import { productStartManufacturing,volumnBagList, selectDynamicBagDropDown } from "../../../slices/manufacturer";

const StartManufacturingForm = (
  formProps
) => {
  const dispatch = useDispatch();
  // const { id, feasibility_id } = useParams();
  const currentCycle = useSelector(selectCurrentCycle)
  const allInitialSteps = useSelector(selectAllInitialSteps)
  const bagDropDown = useSelector(selectDynamicBagDropDown)

const LSM_crypreseve = useMemo(() => {
  const productSlug =  allInitialSteps?.find((it) => it.slug == 'product-manufactured')?.status
  return productSlug == '6' ? true :false
},[allInitialSteps])

const initialValues = useMemo(() => (
  LSM_crypreseve
    ? { bags_id: [] }
    : { blood_amount: "",
       is_monocyte_added: false,
        monocyte_depleted_cells: ""
     }
), [LSM_crypreseve]);

const fetchBagsList = async(id) =>{
   try {
       await dispatch(volumnBagList(id)).unwrap();
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
}
  useEffect(() =>{
  fetchBagsList(currentCycle?.feasibility_assessments_id)
  },[currentCycle?.feasibility_assessments_id])
const validationSchema = Yup.object().shape({
  blood_amount: Yup.string()
    .required("Please enter required CD3+ count")
    .test(
      "max-decimals",
      "At most 2 decimal places are allowed",
      (value) => {
        if (value === undefined || value === null || value === "") return true;
        const parts = value.split('.');
        return parts.length <= 1 || parts[1].length <= 2;
      }
    )
    .test(
      'max-amount',
      '',
      function(value) {
        const { is_monocyte_added, monocyte_depleted_cells } = this.parent;
        const totalCD3 = parseFloat(currentCycle?.remaining_blood) || 0;
        const monocyteValue = is_monocyte_added
          ? parseFloat(monocyte_depleted_cells) || 0
          : 0;
        const maxAmount = totalCD3 + monocyteValue;
        if (!totalCD3) return true;
        if (parseFloat(value) > maxAmount) {
          return this.createError({
            message: `Amount must be less than or equal to ${maxAmount} cells`
          });
        }
        return true;
      }
    ),
});
  const handleSubmit = async (values) => {
    try {
      // Prepare API payload with the selected restart option
       const payload = {
          subject_id: formProps?.subject_id,
          feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
          product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
          qr_code_generated_id: formProps?.qr_code_generated_id,
          ...(LSM_crypreseve
            ? { bags_id: values.bags_id, cycle_no: currentCycle?.cycle }
            : { blood_amount: values.blood_amount, ...(values.is_monocyte_added && {
              monocyte_depleted_cells: values.monocyte_depleted_cells,
            }), }),
        };
        const res = await dispatch(productStartManufacturing(payload)).unwrap();
      if (res?.status === 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LSM_crypreseve ? startValidationSchema : validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = useMemo(() => (
  LSM_crypreseve
    ? [
        {
          label: "Select Required Bags",
          type: "checkbox",
          name: "bags_id",
          required: true,
          boundary: true,
          options: bagDropDown,
        },
      ]
    : [
        {
          label: "Total CD3+ Count Received",
          type: "number",
          disabled: true,
          placeholder: currentCycle?.remaining_blood || 0,
          extraContent: "x10⁶ Cells",
        },
        //   {
        //   label: "Added Monocyte depleted cells",
        //   type: "checkbox",
        //   name: "is_monocyte_added",
        // },

        
        // {
        //   label: "Added Monocyte depleted cells",
        //   type: "number",
        //   name: "monocyte_depleted_cells",
        //   placeholder: "Added Monocyte depleted cells",
        //   extraContent: "x10⁶ Cells",
        //   showWhen: (values) => values?.is_monocyte_added === true,
        // },
        {
          label: "Required CD3+ Count",
          type: "number",
          name: "blood_amount",
          placeholder: "Enter CD3+ Count",
          required: true,
          extraContent: "x10⁶ Cells",
        },
      ]
), [LSM_crypreseve, bagDropDown, currentCycle]);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => {
          if (props.showWhen && !props.showWhen(formik.values)) {
          return null;
           }

  return (
    <Grid key={key} item xs={12}>
      <FormikControl formik={formik} {...props} />
    </Grid>
  );
})}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              // loading={isLoading}
              loading={formik.isSubmitting}  
              disabled={formik.isSubmitting}
              sx={{ backgroundColor: "#3571FF" }}
            >
             Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default StartManufacturingForm;
